import { usePrefersReducedMotion } from '../usePrefersReducedMotion';
import { useRevealedCount } from '../useRevealedCount';

type Result = Readonly<{
	/**
	 * The count the copy, effects and screen-reader status show.
	 */
	displayCount: number;
	/**
	 * The count the DS stepper shows. It lags `displayCount` while the pop plays over it, so a step reads as
	 * filling in. With reduced motion there is nothing to wait for.
	 */
	stepperCount: number;
	isRevealing: boolean;
	showEffects: boolean;
}>;

/**
 * What the Share Goal Counter shows for a given share `count`, paced by `useRevealedCount`.
 */
export function useShareGoalCounterDisplay(count: number): Result {
	const { displayCount, settledCount } = useRevealedCount(count);
	const prefersReducedMotion = usePrefersReducedMotion();

	return {
		displayCount,
		stepperCount: prefersReducedMotion ? displayCount : settledCount,
		isRevealing: settledCount < displayCount,
		showEffects: !prefersReducedMotion,
	};
}
